import { render } from "./ProfileSocial.vue?vue&type=template&id=dd97dd80&scoped=true&ts=true"
import script from "./ProfileSocial.vue?vue&type=script&lang=ts"
export * from "./ProfileSocial.vue?vue&type=script&lang=ts"

import "./ProfileSocial.vue?vue&type=style&index=0&id=dd97dd80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd97dd80"]])

export default __exports__